import React from 'react';
import Switch48Sfp from './templates/Switch48Sfp';
import Server1U from './templates/Server1U';
import Server2U from './templates/Server2U';
import PatchPanel from './templates/PatchPanel';
import GenericDevice from './templates/GenericDevice';
import { resolveDiagramTemplate, getDiagramConfig } from './utils';

const EnhancedRackDevice = ({
  deviceRecord,
  ports,
  selectedPortId,
  connectedPortIds,
  onPortClick,
  onRegisterAnchor,
  readOnly = false,
}) => {
  const template = resolveDiagramTemplate(deviceRecord);
  const diagramConfig = getDiagramConfig(deviceRecord);
  const props = {
    ports,
    diagramConfig,
    selectedPortId,
    connectedPortIds,
    onPortClick: readOnly ? undefined : onPortClick,
    onRegisterAnchor: readOnly ? undefined : onRegisterAnchor,
  };

  switch (template) {
    case 'switch-48-sfp':
      return <Switch48Sfp {...props} />;
    case 'server-1u':
      return <Server1U {...props} />;
    case 'server-2u':
      return <Server2U {...props} />;
    case 'patch-panel':
    case 'patchbox':
      return <PatchPanel {...props} />;
    default:
      return (
        <GenericDevice
          {...props}
          label={deviceRecord?.equipment_name || 'Device'}
        />
      );
  }
};

export default EnhancedRackDevice;
